// extracted by mini-css-extract-plugin
export default {"flex_contain":"capsLoader_flex_contain__FsARd","logo":"capsLoader_logo__C5y6q"};